import React from "react";
import { MenuDatas } from "../components/Datas";
import { Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// Map menu paths to feature names for RBAC
const pathToFeature = {
  "/dashboard": "dashboard",
  "/patients": "patients",
  "/doctors": "professionals",
  "/facility": "facility",
  "/receptions": "staffs",
  "/appointments": "appointments",
  "/payments": "payments",
  "/invoices": "invoices",
  "/orders": "orders",
  "/services": "services",
  "/medicine": "medicine",
  "/campaigns": "campaigns",
  "/settings": "settings",
};

function Sidebar() {
  const { canAccess, user, loading } = useAuth();

  // active link
  const currentPath = (path) => {
    const currentPath =
      window.location.pathname.split("/")[1] === path.split("/")[1];
    if (currentPath) {
      return path;
    }
    return null;
  };

  // Filter menu items based on user role
  const filteredMenu = MenuDatas.filter((item) => {
    const feature = pathToFeature[item.path];
    // If no mapping, show the item (safe default)
    if (!feature) return true;

    if (loading) {
      return <div>Loading...</div>;
    }
    // If no staffRole set, show basic items only (safer than showing all)
    if (!user?.staffRole) {
      return ["dashboard", "patients", "appointments"].includes(feature);
    }
    // Check if user can access this feature
    return canAccess(feature);
  });

  return (
    <div
      style={{ scrollbarWidth: "none" }}
      className='no-scrollbar h-screen w-[85px] overflow-y-scroll border-border bg-white px-4 py-6 xl:h-screen xl:shadow-lg'
    >
      <Link to='/dashboard'>
        <div className='flex flex-row items-end'>
          <h1 className='text-[16px] font-[600] text-black'>avijo</h1>
          <h6 className='text-[8px] font-[500] italic text-[#12CDB7]'>Alpha</h6>
        </div>
      </Link>
      <div className='flex-colo mt-4 gap-2'>
        {filteredMenu.map((item, index) => (
          <Link
            to={item.path}
            key={index}
            className={`transitions group flex w-full flex-col items-center gap-4 rounded-lg p-1`}
          >
            <item.icon
              className={`group-hover:text-subMain ${currentPath(item.path) === item.path
                  ? "text-[#12CDB7]"
                  : "text-gray-500"
                } h-[16] w-[16px]`}
            />
            <p
              className={`text-[10px] font-medium group-hover:text-subMain ${currentPath(item.path) === item.path
                  ? "text-[#12CDB7]"
                  : "text-gray-500"
                }`}
            >
              {item.title}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Sidebar;
